/**
 * Keycloak Configuration
 * --------------------
 * Configures the Keycloak instance.
 *
 * @author  Harvinder Singh <harvinder@maropost.com>
 * @created 2025-09-12
 */

import Keycloak from 'keycloak-js';
import { AppConfig } from '../config';

/**
 * Keycloak environment variables for configuration
 */ 
const config = {
  url: AppConfig.KEYCLOAK_URL,
  realm: AppConfig.KEYCLOAK_REALM,
  clientId: AppConfig.KEYCLOAK_CLIENT_ID,
}


/**
 * Create a Keycloak instance using configuration
 */
const keycloak = new Keycloak(Object.freeze(config));

export default keycloak;
